import api from './axiosConfig';
import { INFO_DISCLOSURE_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';


const mockTeamData = [
    { subsection: 'Corporate environmental report', title: '山东潍坊润丰化工股份有限公司', image_url: '/assets/images/info/portada-01.webp', link_url: '/assets/docs/1-山东潍坊润丰化工股份有限公司.pdf' },
    { subsection: 'Corporate environmental report', title: '青岛润农化工有限公司', image_url: '/assets/images/info/portada-02.webp', link_url: '/assets/docs/2-青岛润农化工有限公司.pdf' },
    { subsection: 'Corporate environmental report', title: '宁夏格瑞精细化工有限公', image_url: '/assets/images/info/portada-03.webp', link_url: '/assets/docs/3-宁夏格瑞精细化工有限公司.pdf' },
    { subsection: 'Corporate environmental report', title: '宁夏汉润生物科技有限公司', image_url: '/assets/images/info/portada-04.webp', link_url: '/assets/docs/4-宁夏汉润生物科技有限公司.pdf' },

    { subsection: 'Environmental monitoring report', title: '润丰股份东厂区', image_url: '/assets/images/info/portada-05.webp', link_url: '/assets/docs/5-润丰股份东厂区.pdf' },
    { subsection: 'Environmental monitoring report', title: '润丰股份西厂区', image_url: '/assets/images/info/portada-06.webp', link_url: '/assets/docs/6-润丰股份西厂区.pdf' },
    { subsection: 'Environmental monitoring report', title: '润丰股份北厂区', image_url: '/assets/images/info/portada-07.webp', link_url: '/assets/docs/7-润丰股份北厂区.pdf' },

    { subsection: 'Social responsibility report', title: '2022年社会责任报告', image_url: '/assets/images/info/portada-08.webp', link_url: '/assets/docs/8-2022年社会责任报告.pdf' },

];

export const fetchInfoDisclosure = async () => {
    // return mockTeamData;

    try {
        const response = await api.get(INFO_DISCLOSURE_ENDPOINT());
        return response.data;
    } catch (error) {
        console.error("Error fetching fetchInfoDisclosure data", error);

        await logError('info_disclosure_fetch', error, {
            endpoint: INFO_DISCLOSURE_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        return mockTeamData;
    }
};
